import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const MetaContext = createContext({ ufs: [], enquadramentos: [], ncms: [], origens: [] });

export const MetaProvider = ({ children }) => {
  const [meta, setMeta] = useState({ ufs: [], enquadramentos: [], ncms: [], origens: [], unidades: [] });
  const [carregando, setCarregando] = useState(true);

  const recarregar = () =>
    api
      .get("/meta")
      .then((r) => setMeta(r.data))
      .catch(() => {})
      .finally(() => setCarregando(false));

  useEffect(() => {
    recarregar();
  }, []);

  const value = useMemo(
    () => ({
      ...meta,
      carregando,
      recarregar,
      ufNome: (s) => meta.ufs.find((u) => u.sigla === s)?.nome || s,
      enqNome: (c) => meta.enquadramentos.find((e) => e.codigo === c)?.nome || c,
      enqCurto: (c) => meta.enquadramentos.find((e) => e.codigo === c)?.curto || c,
    }),
    [meta, carregando]
  );

  return <MetaContext.Provider value={value}>{children}</MetaContext.Provider>;
};

export const useMeta = () => useContext(MetaContext);
